import { FunctionComponent, PropsWithChildren } from "react";

import { Provider, ErrorBoundary } from "@rollbar/react";

interface Props {
  accessToken: string;
  environment: string;
  codeVersion: string;
  captureUncaught?: boolean;
  captureUnhandledRejections?: boolean;
}

export const RollbarProvider: FunctionComponent<PropsWithChildren<Props>> = ({
  accessToken,
  environment,
  codeVersion,
  captureUncaught = true,
  captureUnhandledRejections = true,
  children,
}) => (
  <Provider
    config={{
      accessToken,
      environment,
      captureUncaught,
      captureUnhandledRejections,
      payload: {
        codeVersion,
        environment,
      },
    }}
  >
    <ErrorBoundary>{children}</ErrorBoundary>
  </Provider>
);
